import React, { useState } from 'react'
import { Flex, Box } from '@rebass/grid'
import styled from 'styled-components'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import Checkbox from '@material-ui/core/Checkbox'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

const RadioTitle = styled.h3`
  font-family: Heebo;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  color: #333333;
  margin-bottom: 10px;
`
const RadioSubtitle = styled.p`
  font-family: Heebo;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #696973;
  margin-bottom: 25px;
`

const SelectorTitle = styled.h3`
  font-family: Heebo;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  color: #333333;
  margin-bottom: 10px;
`
const SelectorSubtitle = styled.p`
  font-family: Heebo;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #696973;
  margin-bottom: 25px;
`

const theme = createMuiTheme({
  palette: {
    primary: { main: '#6F16FF' },
    secondary: { main: '#6F16FF' },
  },
  typography: { useNextVariants: true },
})

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  font-style: normal;
  font-weight: normal;
  font-family: Heebo;
  align-items: center;
`

export const FormContainer = props => (
  <Flex flexDirection="row">
    <Flex width={1} flexDirection="column">
      <MuiThemeProvider theme={theme}>
        <Form noValidate autoComplete="off">
          {props.children}
        </Form>
      </MuiThemeProvider>
    </Flex>
  </Flex>
)

export const Selector = props => (
  <>
    {props.item.title && <SelectorTitle>{props.item.title}</SelectorTitle>}
    {props.item.subtitle && (
      <SelectorSubtitle>{props.item.subtitle}</SelectorSubtitle>
    )}
    <TextField
      required
      select
      style={{
        display: 'flex',
      }}
      margin="normal"
      variant="outlined"
      {...props}
    >
      {props.options.map((option, i) => {
        if (props.identifier) {
          return (
            <MenuItem key={i} value={`${props.identifier}_${i + 1}`}>
              {option[`${props.identifier}_${i + 1}`]}
            </MenuItem>
          )
        } else {
          return (
            <MenuItem key={i} value={option}>
              {option}
            </MenuItem>
          )
        }
      })}
    </TextField>
  </>
)

export const TextInput = props => (
  <TextField
    required
    style={{
      display: 'flex',
    }}
    margin="normal"
    variant="outlined"
    {...props}
  />
)

export const MessageBox = props => (
  <TextField
    {...props}
    margin="normal"
    fullWidth
    multiline={true}
    rows={6}
    rowsMax={10}
    variant="outlined"
  />
)

export const Text = props => (
  <Box width={props.width || [1, 1 / 3]} pr={[0, 30]}>
    <TextField
      required
      style={{
        display: 'flex',
      }}
      margin="normal"
      variant="outlined"
      {...props}
    />
  </Box>
)

export const FieldContainer = props => (
  <Box width={[1, 1 / 3]} pr={[0, 30]} style={props.style}>
    {props.children}
  </Box>
)

export const RadioInput = props => (
  <>
    {props.aslabel && (
      <FormLabel style={{ marginBottom: 10 }} component="legend">
        {props.title || props.radio.title}
      </FormLabel>
    )}
    {!props.aslabel && (
      <RadioTitle>{props.title || props.radio.title}</RadioTitle>
    )}
    {!props.aslabel && (
      <RadioSubtitle>{props.subtitle || props.radio.subtitle}</RadioSubtitle>
    )}
    <FormControl component="fieldset" style={{ ...props.style }}>
      <RadioGroup
        aria-label="position"
        name="position"
        row
        {...props}
        style={{ marginBottom: 10 }}
      >
        <FormControlLabel
          value={props.radio.option_1}
          control={<Radio />}
          label={`${props.radio.option_1}`}
          labelPlacement="start"
        />
        <FormControlLabel
          value={props.radio.option_2}
          control={<Radio />}
          label={`${props.radio.option_2}`}
          labelPlacement="start"
        />
      </RadioGroup>
    </FormControl>
  </>
)
